import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useState } from "react";

function VariantFeatureList({
  variant,
  features,
  onDelete,
  onReorder,
  onToggleUnavailable,
}) {
  const [dragIndex, setDragIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);

  const handleDragStart = (visibleIndex) => {
    setDragIndex(visibleIndex);
  };

  const handleDragOver = (event, visibleIndex) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    if (overIndex !== visibleIndex) {
      setOverIndex(visibleIndex);
    }
  };

  const handleDrop = (event, visibleIndex) => {
    event.preventDefault();
    if (dragIndex !== null && dragIndex !== visibleIndex) {
      onReorder(variant, dragIndex, visibleIndex);
    }
    setDragIndex(null);
    setOverIndex(null);
  };

  const handleDragEnd = () => {
    setDragIndex(null);
    setOverIndex(null);
  };

  if (features.length === 0) {
    return (
      <div className="vf-feature-empty">
        No features yet. Add one below.
      </div>
    );
  }

  return (
    <div className="vf-feature-list">
      {features.map(({ feature, featureIndex }, visibleIndex) => {
        const isUnavailable = Boolean(feature.unavailable);
        return (
          <div
            key={`${variant}-${featureIndex}`}
            className={[
              "vf-feature-item",
              isUnavailable ? "is-unavailable" : "",
              dragIndex === visibleIndex ? "is-dragging" : "",
              overIndex === visibleIndex && dragIndex !== visibleIndex
                ? "is-drop-target"
                : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onDragOver={(event) => handleDragOver(event, visibleIndex)}
            onDrop={(event) => handleDrop(event, visibleIndex)}
          >
            <button
              type="button"
              className="vf-feature-drag"
              draggable
              aria-label="Drag to reorder"
              onDragStart={() => handleDragStart(visibleIndex)}
              onDragEnd={handleDragEnd}
            >
              <DragIndicatorIcon fontSize="small" />
            </button>
            <span className="vf-feature-text">{feature.feature}</span>
            <FormControlLabel
              className="vf-feature-unavailable"
              control={
                <Checkbox
                  size="small"
                  checked={isUnavailable}
                  onChange={() => onToggleUnavailable(featureIndex)}
                />
              }
              label="Unavailable"
            />
            <button
              type="button"
              className="vf-feature-remove"
              onClick={() => onDelete(featureIndex)}
              aria-label="Remove feature"
            >
              <HighlightOffIcon fontSize="small" />
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default VariantFeatureList;
